import { InjectionToken } from '@angular/core';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');
export const TESS_API_URL = new InjectionToken<string>('TESS_API_URL');

export function buildApiUrl(baseUrl: string, path: string): string {
  const normalizedUrl = baseUrl.replace(/\/$/, '');
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;

  return `${normalizedUrl}${normalizedPath}`;
}
